import { render, staticRenderFns } from "./ed-bootstrap-modal.vue?vue&type=template&id=592d7011&scoped=true&"
import script from "./ed-bootstrap-modal.ts?vue&type=script&lang=js&"
export * from "./ed-bootstrap-modal.ts?vue&type=script&lang=js&"
import style0 from "./ed-bootstrap-modal.scss?vue&type=style&index=0&id=592d7011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d7011",
  null
  
)

export default component.exports